import { EmbedFormat } from 'types'

export const iframeFormatToEmbedMode = (embedFormat: EmbedFormat) => {
  switch (embedFormat) {
    case 'url':
    case 'smartLink':
      return 'inline'
    case 'card':
      return 'card'
    case 'embed':
      return 'frame'
  }
}

export const embedModeToIframeFormat = (embedMode: 'inline' | 'card' | 'frame') => {
  switch (embedMode) {
    case 'inline':
      return 'smartLink'
    case 'card':
      return 'card'
    case 'frame':
      return 'embed'
  }
}
